import { render } from "@/components/pages/obd/individual/readinessStatus/ObdReadinessStatus.html?vue&type=template&id=18a95a9c&external"
import script from "@/components/pages/obd/individual/readinessStatus/ObdReadinessStatus.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/individual/readinessStatus/ObdReadinessStatus.js?vue&type=script&lang=js&external"

import "@/components/pages/obd/individual/readinessStatus/ObdReadinessStatus.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__